var lists_default = {
  "fontElementMap": "q870R",
  "orderedlist": "B1fK8",
  "bulletedlist": "mrVw3",
  "listItem": "f6O8Z"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
